import components from "./components/lang.en";
import layouts from "./layouts/lang.en";
import stores from "./stores/lang.en";
import domain from "./domain/lang.en";

export default {
	"common-team": {
		components,
		layouts,
		stores,
		domain,
	},
};
